document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  // 📌 Airbnb-style fade-in učitavanje proizvoda
  gsap.utils.toArray(".product-card").forEach((product) => {
    gsap.from(product, {
      opacity: 0,
      y: 20,
      duration: 0.8,
      ease: "power2.out",
      scrollTrigger: {
        trigger: product,
        start: "top 85%",
        toggleActions: "play none none reverse",
      },
    });
  });

  // 📌 Simulacija učitavanja proizvoda (Airbnb-style)
  const productContainer = document.querySelector(".product-list");
  if (productContainer) {
    for (let i = 0; i < 6; i++) {
      const skeleton = document.createElement("div");
      skeleton.classList.add("skeleton-loader");
      skeleton.innerHTML = `
        <div class="skeleton-image"></div>
        <div class="skeleton-box"></div>
        <div class="skeleton-box"></div>
      `;
      productContainer.appendChild(skeleton);
    }

    // Simulacija pravog učitavanja
    setTimeout(() => {
      document.querySelectorAll(".skeleton-loader").forEach((loader) => {
        loader.remove();
      });
      document.querySelectorAll(".product-card").forEach((product) => {
        product.style.display = "block";
      });
    }, 2000);
  }
});
